import SelectPage from './SelectPage';

export default SelectPage;
